var date = {
  after: function after(val, min) {
    return val - min > 0;
  },
  before: function before(val, max) {
    return val - max < 0;
  },
  between: function between(val, range) {
    return val - range[0] > 0 && val - range[1] < 0;
  },
  equal: function equal(val, _equal) {
    return val - _equal === 0;
  },
  type: function type(val) {
    return val instanceof Date;
  }
};
module.exports = date;